import React from "react";

import "./styles.css";

const TicketSelectorTabControls = (props) => {

  return (
    <div className="ticket-selector__tablist" role="tablist">
      {props.tabs.map((tab) => (
        <button
          type="button"
          className={`ticket-selector__tablist-btn ${tab.id === props.activeTabId ? "ticket-selector__tablist-btn--active" : ""}`}
          key={tab.id}
          id={tab.id}
          onClick={() => props.onChangeActiveTab(tab.id)}
        >{tab.title}</button>
      ))}
    </div>
  );
};

export default TicketSelectorTabControls;
